<nz-form-item [formGroup]="formConfig.parentForm">
	<nz-form-label [nzSpan]="6">{{ schema?.title || schemaKey | translate }}</nz-form-label>
	<nz-form-control [nzSpan]="18" [nzErrorTip]="errorTemplate">
		<nz-select [ngClass]="{
				'ft-edit': !formConfig.viewOnly,
				'ft-view': formConfig.viewOnly,
				'nzDisabled': formConfig.viewOnly
			}" formControlName="{{ key }}" [required]="required" (ngModelChange)="setValid($event)">
			<ng-container *ngIf="schema?.$txkey">
				<nz-option *ngFor="let item of schema?.enum" [nzValue]="item" nzLabel="{{ schema.$txkey + '.' + item | translate }}"></nz-option>
			</ng-container>
			<ng-container *ngIf="!schema?.$txkey">
				<nz-option *ngFor="let item of schema?.enum" [nzValue]="item" nzLabel="{{ item }}"></nz-option>
			</ng-container>
		</nz-select>
		<ng-template #errorTemplate let-control>
			<ng-container *ngIf="control.hasError('validation')">{{control.errors.validation}}</ng-container>
			<ng-container *ngIf="control.hasError('required')">{{ 'form.input.required' | translate:{itemName : schema?.title || schemaKey | translate } }}</ng-container>
		</ng-template>
	</nz-form-control>
</nz-form-item>
